import { UserManager } from 'oidc-client';

const userManagerConfig = {
    client_id: 'neit_contributi_impresa_spa',
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/loginCallback`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/logoutCallback`,
    response_type: 'code',
    response_mode: 'query',
    scope: 'openid profile email NEiT.profile neit_contributi_impresa',
    authority: process.env.REACT_APP_IDENTITY_PROVIDER,
    acr_values: "tenant:" + window.location.hostname.split(".")[0],
    filterProtocolClaims: true,
    loadUserInfo: true,
    revokeAccessTokenOnSignout: true,
    clockSkew: 3600
};

const userManager = new UserManager(userManagerConfig);

export default userManager;